import { Text, View } from "@react-pdf/renderer";

import { CreateBillDto } from "../../model/bill/dto/CreateBillDto";
import { UpdateBillDto } from "../../model/bill/dto/UpdateBillDto";
import { Bill } from "../../model/bill/types/Bill";

type PDFFooterProps = {
  dto: CreateBillDto | UpdateBillDto | Bill;
};

export const PDFFooter: React.FC<PDFFooterProps> = ({ dto }) => {
  const { billDetails, receivedBy } = dto;

  return (
    <View style={{ flexDirection: "row", fontSize: 12 }}>
      <View style={{ flex: 1 }}>
        <Text>Thank you for your order!</Text>
      </View>

      <View
        style={{ flex: 2.5, border: "1px solid black", flexDirection: "row" }}
      >
        <View
          style={{
            borderRight: "1px solid black",
            padding: 12,
            width: "10rem",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <Text style={{ color: "red" }}>TERMS & CONDITIONS</Text>
          <Text
            style={{
              display: "flex",
              flexWrap: "wrap",
              borderBottom: "2px solid black",
              paddingBottom: 6,
            }}
          >
            RECEIVED BY: {receivedBy}
          </Text>
        </View>
        <View style={{ borderRight: "1px solid black", padding: 12 }}>
          <Text>SUBTOTAL:</Text>
          <Text>GST:</Text>
          <Text>PST:</Text>
          <Text>GRAND TOTAL:</Text>
        </View>
        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: 12,
          }}
        >
          <Text style={{ fontSize: 30, fontWeight: "bold" }}>
            {billDetails?.reduce(
              (prev, curr) => prev + Number(curr.amount || 0),
              0
            )}
            $
          </Text>
        </View>
      </View>
    </View>
  );
};
